import { Routes } from '@angular/router';
import { HomepageComponent } from '../features/homepage/homepage.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: HomepageComponent
  },
  {
    path: 'login',
    loadComponent: () => import('../features/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('../features/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('../features/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('../features/register/register.component').then((m) => m.RegisterComponent)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('../features/profile/profile.component').then((m) => m.ProfileComponent)
  },
  {
    path: 'profile/family',
    canActivate: [authGuard],
    loadComponent: () => import('../features/profile/manage-family/manage-family.component').then((m) => m.ManageFamilyComponent)
  },
  {
    path: 'claim-account',
    canActivate: [authGuard],
    loadComponent: () => import('../features/profile/claim-account/claim-account.component').then((m) => m.ClaimAccountComponent)
  },
  {
    path: 'classes',
    loadComponent: () => import('../features/classes/classes.component').then((m) => m.ClassesComponent)
  },
  {
    path: 'classes/:id',
    loadComponent: () => import('../features/classes/class-detail/class-detail.component').then((m) => m.ClassDetailComponent)
  },
  {
    path: 'studios',
    loadComponent: () => import('../features/studios/studios.component').then((m) => m.StudiosComponent)
  },
  {
    path: 'studios/:id/instructor/:instructorId',
    loadComponent: () => import('../features/studios/instructor-detail/instructor-detail.component').then((m) => m.InstructorDetailComponent)
  },
  {
    path: 'studios/:id/bookPrivate/:instructorId',
    canActivate: [authGuard],
    loadComponent: () => import('../features/studios/book-private/book-private.component').then((m) => m.BookPrivateComponent)
  },
  {
    path: 'bookings/confirmation',
    canActivate: [authGuard],
    loadComponent: () => import('../features/bookings/booking-confirmation.component').then((m) => m.BookingConfirmationComponent)
  },
  {
    path: 'studios/:id',
    loadComponent: () => import('../features/studios/studio-detail/studio-detail.component').then((m) => m.StudioDetailComponent)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('../features/dashboard/dashboard.component').then((m) => m.DashboardComponent)
  },
  {
    path: 'events',
    loadComponent: () => import('../features/events/events.component').then((m) => m.EventsComponent)
  },
  {
    path: 'events/:id/register',
    canActivate: [authGuard],
    loadComponent: () => import('../features/events/performer-registration/performer-registration.component').then((m) => m.PerformerRegistrationComponent)
  },
  {
    path: 'events/:id/vendor-register',
    canActivate: [authGuard],
    loadComponent: () => import('../features/events/vendor-registration/vendor-registration.component').then((m) => m.VendorRegistrationComponent)
  },
  {
    path: 'events/:id/vendor-pay/:businessName',
    canActivate: [authGuard],
    loadComponent: () => import('../features/events/vendor-payment/vendor-payment.component').then((m) => m.VendorPaymentComponent)
  },
  {
    path: 'events/:id/:teamName',
    canActivate: [authGuard],
    loadComponent: () => import('../features/events/performer-payment/performer-payment.component').then((m) => m.PerformerPaymentComponent)
  },
  {
    path: 'events/:id',
    loadComponent: () => import('../features/events/event-detail/event-detail.component').then((m) => m.EventDetailComponent)
  },
  {
    path: 'packages/:studioId',
    loadComponent: () => import('../features/packages/packages.component').then((m) => m.PackagesComponent)
  },
  {
    path: 'purchases/confirmation',
    canActivate: [authGuard],
    loadComponent: () => import('../features/purchases/purchase-confirmation.component').then((m) => m.PurchaseConfirmationComponent)
  },
  {
    path: 'purchases/history',
    canActivate: [authGuard],
    loadComponent: () => import('../features/purchases/purchase-history.component').then((m) => m.PurchaseHistoryComponent)
  },
  {
    path: 'activities/:type/:filter',
    canActivate: [authGuard],
    loadComponent: () => import('../features/activities/activities.component').then((m) => m.ActivitiesComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('../features/legal/privacy-policy.component').then((m) => m.PrivacyPolicyComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import('../features/legal/terms-of-service.component').then((m) => m.TermsOfServiceComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('../features/legal/contact.component').then((m) => m.ContactComponent)
  },
  {
    path: 'help',
    loadComponent: () => import('../features/legal/help-center.component').then((m) => m.HelpCenterComponent)
  },
  {
    path: '**',
    loadComponent: () => import('../features/not-found/not-found.component').then((m) => m.NotFoundComponent)
  }
];
